import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, object = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cc_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("cc_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("cc_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const impersonate = async (userId) => {
    const { data } = await api.post(`/admin/users/${userId}/impersonate`);
    const cur = localStorage.getItem("cc_token");
    if (cur) localStorage.setItem("cc_admin_token", cur);
    localStorage.setItem("cc_token", data.token);
    localStorage.removeItem("cc_assist_sid");
    setUser({ ...data.user, impersonator: data.impersonator });
    return data.user;
  };

  const stopImpersonation = async () => {
    const admin = localStorage.getItem("cc_admin_token");
    if (admin) {
      localStorage.setItem("cc_token", admin);
      localStorage.removeItem("cc_admin_token");
    }
    localStorage.removeItem("cc_assist_sid");
    const { data } = await api.get("/auth/me");
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("cc_token");
    localStorage.removeItem("cc_admin_token");
    localStorage.removeItem("cc_assist_sid");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, impersonate, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
